import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../lib/redux/hook';
import { Logo } from '../../ui/icons/logo';
import { BillowButton } from '../../ui/molecules/billowButton';
import { InputComponent } from '../../ui/molecules/input';
import { SpinnerComponent } from '../../ui/molecules/spinner';
import { otpRequest, otpValidate, setClauses, setConsentEmail, setNumberOrEmail, setOtpValidateStatus, setTerms } from './slice';
import './style.css'

export default function ConsentPage() {

    const [otp, setOtp] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    function detectInputType(input: string): 'email' | 'number' | null {
        const trimmed = input.trim();

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const phoneRegex = /^\+?\d{6,15}$/;

        if (emailRegex.test(trimmed)) {
            return 'email';
        } else if (phoneRegex.test(trimmed)) {
            return 'number';
        } else {
            return null;
        }
    }

    function openStripe() {
        const link = document.createElement('a')
        link.href = customerState.otpValidateResponse
        link.rel = "noreferrer"
        link.target = "_blank"
        link.click()
    }

    const dispatch = useAppDispatch()
    const customerState = useAppSelector(state => state.customer)

    function validate() {
        if (otp.length === 6 && customerState.consents.customer_consense.clauses_accepted && customerState.consents.customer_consense.terms_accepted) {
            dispatch(otpValidate({ ...customerState.consents, otp: otp }))
        }
        else {
            setError(true)
        }
    }

    useEffect(() => {
        if (customerState.otpValidateResponse.includes('http')) {
            setLoading(true)
            const id = setTimeout(() => {
                setLoading(false)
                openStripe()
            }, 2000);
            return () => clearTimeout(id)
        }
    }, [customerState.otpValidateResponse])

    useEffect(() => {
        if (customerState.otpValidateStatus === 'successfully') {
            setOtp('')
            dispatch(setTerms(false))
            dispatch(setClauses(false))
            dispatch(setOtpValidateStatus('idle'))
        }
    }, [customerState.otpValidateStatus])

    return (
        <div className=' w-full flex '>
            <div className=' background min-h-screen rounded-r-[40px] w-0 sm:w-[60%] bg-[#170264] flex justify-center items-center'>
            </div>
            <div className=' w-full sm:w-[40%] flex flex-col gap-2 justify-center p-20 items-center'>
                <div className=' flex flex-col w-full lg:w-[352px] h-full items-center justify-center gap-2'>
                    <div className=' w-[40%]'>
                        <Logo width={'100%'} />
                    </div>
                    {customerState.otpRequestStatus !== 'successfully' && <span className=' text-heading-sm text-[#262645] font-bold text-center py-2 pt-[60px]'>Inserisci la tua email per completare la registrazione</span>}
                    {(customerState.otpRequestStatus === 'idle' || customerState.otpRequestStatus === 'failed') &&
                        <>
                            <InputComponent onKeyDown={(e) => {
                                if (e.key === 'Enter' && detectInputType(customerState.numberOrEmail) !== null) {
                                    dispatch(otpRequest({ mail: customerState.numberOrEmail, duration: 400 }))
                                }
                            }
                            } onChangeText={(text) => {
                                dispatch(setNumberOrEmail(text))
                                dispatch(setConsentEmail(text))
                            }} type={'text'} label='Email' />
                            {customerState.otpRequestStatus === 'failed' && <span className=' text-red-500 text-text-md'>Email non valida</span>}
                            <div className=' py-5 w-full flex justify-center'>
                                <BillowButton onClick={() => {
                                    dispatch(otpRequest({ mail: customerState.numberOrEmail, duration: 400 }))
                                }}
                                    disabled={detectInputType(customerState.numberOrEmail) === null} label='Prosegui' iconPosition={'off'} variant={'solid'} />
                            </div>
                        </>
                    }
                    {customerState.otpRequestStatus === 'loading' &&
                        <div className=' w-full justify-center flex'>
                            <SpinnerComponent />
                        </div>
                    }
                    {customerState.otpRequestStatus === 'successfully' &&
                        <div className=' flex flex-col gap-2 pt-6'>
                            <InputComponent disabled={loading} onChangeText={(setOtp)} value={otp} label="Inserisci l'OTP appena inviato alla tua email" type={'text'} />
                            <div className=' flex gap-2 items-start'>
                                <input className='cursor-pointer mt-[3px]' disabled={loading} checked={customerState.consents.customer_consense.terms_accepted} onChange={(e) => dispatch(setTerms(e.target.checked))} type='checkbox' placeholder='Consenso 1' />
                                <span onClick={() => dispatch(setTerms(!customerState.consents.customer_consense.terms_accepted))} className=' text-text-sm text-neutral-500 font-semibold cursor-pointer'>
                                    Dichiaro di aver letto e accettato i <a onClick={(e) => e.stopPropagation()} rel='noreferrer noopener' target='_blank' href='https://madfarm.it/billow-termini-e-condizioni/' className=' text-[#6237fb]'>Termini e Condizioni</a> del servizio.
                                </span>
                            </div>
                            <div className=' flex gap-2 items-start'>
                                <input className='cursor-pointer mt-[3px]' disabled={loading} checked={customerState.consents.customer_consense.clauses_accepted} onChange={(e) => dispatch(setClauses(e.target.checked))} type='checkbox' placeholder='Consenso 2' />
                                <span onClick={() => dispatch(setClauses(!customerState.consents.customer_consense.clauses_accepted))} className=' text-text-sm text-neutral-500 font-semibold cursor-pointer'>
                                    Acconsento al trattamento dei miei dati personali per la gestione dei pagamenti, della fatturazione e delle comunicazioni relative al servizio, come descritto nell’<a onClick={(e) => e.stopPropagation()} rel='noreferrer noopener' target='_blank' href='https://madfarm.it/billow-privacy-policy/' className=' text-[#6237fb]'>Informativa Privacy</a>.
                                </span>
                            </div>
                            {(customerState.otpValidateStatus === 'failed' && <span className=' text-red-500 text-text-md'>Codice non valido o già usato</span>)}
                            {(error && <span className=' text-red-500 text-text-md'>Hai inserito un codice sbagliato o non hai dato i consensi</span>)}
                            {(customerState.otpValidateResponse.includes('expired') && <span className=' text-warning-500 text-text-md'>Codice scaduto, controlla la mail per il nuovo codice</span>)}
                            <BillowButton disabled={!(customerState.consents.customer_consense.terms_accepted && customerState.consents.customer_consense.clauses_accepted && otp.length === 6)} onClick={() => validate()} iconPosition={'off'} variant={'solid'} label='Procedi' />
                            {loading && <div className=' flex items-center justify-center w-full'>
                                <SpinnerComponent />
                            </div>}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
